var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAchBank(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.74787 0.514811C9.82839 0.47309 9.92416 0.47309 10.0047 0.514811L19.4568 5.41441C19.7162 5.54889 19.6206 5.94111 19.3284 5.94111H17.0989V7.07458H16.1729L16.1726 14.6598C16.1726 14.6711 16.1722 14.6823 16.1715 14.6935C16.1706 14.7076 16.1692 14.7216 16.1672 14.7354H18.2464V16.1422H19.6414V17.1884H0.111206V16.1422H1.50622V14.7354H3.59874V7.07458H2.65363V5.94111H0.424188C0.131977 5.94111 0.0363591 5.54889 0.295788 5.41441L9.74787 0.514811ZM15.1267 8.83455V7.07458H12.6851V14.7354H15.1317C15.1298 14.7221 15.1284 14.7086 15.1275 14.695C15.1267 14.6833 15.1263 14.6716 15.1263 14.6598V8.8536C15.1263 8.84721 15.1264 8.84087 15.1267 8.83455ZM4.645 7.07458V14.7354H7.08627V7.07458H4.645ZM8.13253 7.07458V14.7354H11.6388V7.07458H8.13253Z",
    fill: "#474973"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAchBank);
export default __webpack_public_path__ + "static/media/ach-bank.25eb605052e367b8471cf777342f8730.svg";
export { ForwardRef as ReactComponent };